import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Payment from '../components/Payment';
import PaymentSelection from '../components/PaymentSelection';
import RatingSelection from '../components/RatingSelection';
import FeedbackForm from '../components/FeedbackForm';
import { usePaymentIntent } from '../contexts/PaymentIntentProvider';
import { getTipRequest } from '../utils/tipRequestHelpers';


const stripePromise = loadStripe('pk_live_51P0sqiBWPB7fd0YpXYBbWB1HUD7AnMoUkKGrtjk6FjfHLCSKfjnq34bE4xsRlgtu14Ho8eCyh8vV3wjmivocXbQF00vB1SzR9i', {
    stripeAccount: 'acct_1EaS1bIcVamZvsrB',
  });

const StripeContainer = () => {
    const { id } = useParams();

    const {
        clientSecret,
        paymentRequestDetails,
        setPaymentRequestDetails,
        rating,
        setRating,
        feedbackComplete,
        setFeedbackComplete
    } = usePaymentIntent();

    useEffect(() => {
        const loadTipRequest = async () => {
            try {
                const data = await getTipRequest(id);
                setPaymentRequestDetails(data);

                // Already rated on a previous visit — skip the rating gate
                // (and the feedback step) entirely
                if (data.rating) {
                    setRating(data.rating);
                    setFeedbackComplete(true);
                }
            } catch (err) {
                console.error('Error fetching tip request:', err);
            }
        };

        loadTipRequest();
    }, [id, setPaymentRequestDetails, setRating, setFeedbackComplete]);

    if (!paymentRequestDetails) {
        return <p className="center-text">Loading...</p>
    }

    // The tip UI is never rendered until a rating has been saved
    if (!rating) {
        return <RatingSelection/>
    }

    if (rating.rating === 'sad') {
        if (!feedbackComplete) {
            return <FeedbackForm/>
        }

        return(
            <div className="payment-container">
                <p className="feedback-thank-you">We are grateful for the feedback and will strive to improve your experience.</p>
            </div>
        )
    }

    if(!clientSecret) {
        return <PaymentSelection/>
    }

    const options = { clientSecret };

    return(
        <>
            <PaymentSelection/>
            <div className="payment-container">
                <Elements stripe={ stripePromise } options={ options } >
                    <Payment />
                </Elements>
            </div>
        </>
    )
}

export default StripeContainer;
